import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import ReactGA from "react-ga4";

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

ReactGA.initialize("G-WGDBZ78Y66");
/*ReactGA.initialize([{
    trackingId: "G-WGDBZ78Y66",
    gaOptions: {
        debug_mode: true
    },
    gtagOptions: {
        debug_mode: true
    }
}]);*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
